import type { Invoice as RxInvoice } from "$global-providers/rxdb-provider/collections/invoice";
import type { RxDocument } from "rxdb";

/**
 * Removes RxDB's nested reactive proxies before data crosses into the pure
 * invoice model. JSON is the collection's persisted wire format, so this also
 * keeps the adapter limited to fields that can actually be stored and synced.
 */
export const invoiceRecordFromDocument = (
  doc: RxDocument<RxInvoice>,
): RxInvoice => JSON.parse(JSON.stringify(doc.toJSON())) as RxInvoice;
